<template>

    <h4>{{getInterfaceText('title_complete_your_rider_experience')}}</h4>

    <div class="items-container">
        <div v-for="item in Cart.RelatedProducts" :key="item.Id" class="item">
            <div class="image">
                <a :href="item.URL" class="item-link track-GA4-event" data-ga4_name="select_item" data-ga4_item_list_name="complete your rider experience" data-ga4_location="mini cart" :data-ga4_items="GA4Items(item)">
                    <picture><img :src="item.ImageMedium" width="128" height="128"></picture>
                </a>
            </div> 
            <h5>{{item.Name}}</h5>
            <div class="price-and-action">
                <div class="price">
                    <template v-if="Cart.EnableLowest30DaysPriceMode == false && item.PriceOriginalToFormat != null && item.PriceOriginalToFormat.length > 0 && item.PriceOriginalToFormat != item.PriceToFormat">
                        <span class="sr-only">Original price: </span>
                        <span class="oldprice">{{item.PriceOriginalToFormat}}</span>
                    </template>
                    <template v-if="Cart.EnableLowest30DaysPriceMode == true && item.PriceScenario == 1">
                        <span class="sr-only">Original price: </span>
                        <span class="oldprice omnibus-mode">{{item.PriceLowest30ToFormat}}</span>
                    </template>
                    <span :class="{ discountprice: hasDiscount(item) }">{{item.PriceToFormat}}</span>

                </div>
                <div class="action">
                    <div class="discovermode-button-component-wrapper">
                        <a :href="item.URL"
                            class="button-component filled icon-only track-GA4-event"
                            data-ga4_name="select_item"
                            data-ga4_item_list_name="complete your rider experience"
                            data-ga4_location="mini cart"
                            :data-ga4_items="GA4Items(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.21842 3.5H1V1.5H3.95301L4.99587 8.8H10.838L12.8608 8.80781L12.381 10.8H3.26128L2.21842 3.5Z" fill="white" />
                                <path d="M6.5 14.25C6.5 13.5596 5.94036 13 5.25 13C4.55964 13 4 13.5596 4 14.25C4 14.9404 4.55964 15.5 5.25 15.5C5.94036 15.5 6.5 14.9404 6.5 14.25Z" fill="white" />
                                <path d="M11.5 14.25C11.5 13.5596 10.9404 13 10.25 13C9.55964 13 9 13.5596 9 14.25C9 14.9404 9.55964 15.5 10.25 15.5C10.9404 15.5 11.5 14.9404 11.5 14.25Z" fill="white" />
                                <path d="M12 7.5V1.5M9 4.5H15" stroke="white" stroke-width="2" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
    
</template>
<script>

    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'RelatedProductsDiscoverMode',
        mixins: [cartMixin, generalMixin],
        template: '#related-products-template',
        data: function () {
            return {
                rpX: null,
                rpLeft: null,
                rpDown: null,
                show: false
            }
        },
        methods: {
            mouseDown(e) {
                e.preventDefault();
                // get element
                var myScroller = document.getElementById('related-items-scroller');
                // down?
                this.rpDown = true;
                // position of click within scroller
                this.rpX = e.pageX;
                // left position of scroller at start of click
                this.rpLeft = myScroller.scrollLeft;
            },
            mouseMove(e) {
                if (this.rpDown) {
                    var newX = e.pageX;
                    Window.handleScrollerMouseMove(this.rpLeft, newX, this.rpX);
                }
            },
            mouseUp() {
                this.rpDown = false;
                Window.handleScrollerMouseUp();
            },
            GA4Items(item) {
                let items = [];
                if (item != null) {
                    items.push(item);
                } else {
                    items = this.Cart.RelatedProducts;
                }

                let result = [];
                for (let item of items) {
                    let newItem = {
                        item_id: 'gearproduct-' + item.Id,
                        item_name: item.Name,
                        index: item.Index,
                        item_brand: item.Brand,
                        item_category: item.Category,
                        item_category2: item.Category2,
                        item_category3: item.Category3,
                        price: item.Price,
                        discount: item.Discount,
                        quantity: 1
                    }
                    result.push(newItem);
                }

                return JSON.stringify(result, null, 2);

            },
            hasDiscount(item) {
                return (
                    (!this.Cart.EnableLowest30DaysPriceMode &&
                        item.PriceOriginalToFormat &&
                        item.PriceOriginalToFormat !== item.PriceToFormat) ||
                    (this.Cart.EnableLowest30DaysPriceMode &&
                        item.PriceScenario == 1)
                )
            }
        },
        computed: {
           
        },
        created() {
            // track mouse for whole body
            document.addEventListener('mousemove', this.mouseMove);

            // track mouse up for whole body
            document.addEventListener('mouseup', this.mouseUp);

            // add interfacetexts
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
